export const pluralize = (singular: string, value: number | null) => {
  return value && value === 1 ? singular :`${singular}s`;
}
